import { css } from '@emotion/core';
import getConfig from 'next/config';
import * as R from 'ramda';

import { outer } from '~/globalStyles';

export const blueBold = css`
  &,
  &:hover,
  &:visited {
    color: ${outer.colors.blueDark};
    font-weight: 500;
    text-decoration: none;
  }

  &:hover {
    -webkit-text-stroke: ${outer.textStroke};
  }
`;

export const basePath = R.pathOr(
  '',
  ['publicRuntimeConfig', 'basePath'],
  getConfig(),
);

// This is useful for links that do not utilize the <Link> element
// and hence do not have the base path prefixed automatically
export const prefixWithBasePath = (value: string): string => {
  return `${basePath}${value}`;
};

export const makeAsPathname = (
  currentAsPath: string,
  langParam: string,
): string => {
  // strip off the lang param if any, from the as.pathname value
  let redirectAsPathname = currentAsPath || '';
  if (!R.isEmpty(langParam)) {
    redirectAsPathname = redirectAsPathname.replace(`/${langParam}`, `/`);
    redirectAsPathname = redirectAsPathname.replace(`//`, `/`);
  }

  // strip off hash if it's in asPathname
  const hashIndexInAsPathname = redirectAsPathname.indexOf('#');
  if (hashIndexInAsPathname >= 0) {
    redirectAsPathname = redirectAsPathname.substring(0, hashIndexInAsPathname);
  }

  // strip off query string portion
  const queryStringIndex = redirectAsPathname.indexOf('?');
  if (queryStringIndex >= 0) {
    // strip off query string
    redirectAsPathname = redirectAsPathname.substring(
      0,
      redirectAsPathname.indexOf('?'),
    );
  }

  return redirectAsPathname;
};
